module.exports = __webpack_public_path__ + "static/img/12.8b069b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/12.png
// module id = 0Lxe
// module chunks = 0